"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Standard = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 18 24" },
        react_1.default.createElement(react_native_svg_1.G, { id: "illustarations-and-Icons", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Icons", transform: "translate(-1167.000000, -1746.000000)" },
                react_1.default.createElement(react_native_svg_1.G, { id: "atom-/-icon-/-filled-/-chargepoint-/-standard", transform: "translate(1164.000000, 1746.000000)" },
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M12,24 C14.0104874,24 21,13.9705627 21,9 C21,4.02943725 16.9705627,0 12,0 C7.02943725,0 3,4.02943725 3,9 C3,13.9705627 9.98951259,24 12,24 Z", id: "Oval", fill: color, "fill-rule": "nonzero" }))))));
};
Standard.defaultProps = {
    color: '#FFBC3D',
    width: 19,
    height: 24,
};
exports.default = react_1.default.memo(Standard);
